import { render, staticRenderFns } from "./ManageCustomPages.vue?vue&type=template&id=3576edca&scoped=true"
import script from "./ManageCustomPages.vue?vue&type=script&lang=js"
export * from "./ManageCustomPages.vue?vue&type=script&lang=js"
import style0 from "./ManageCustomPages.vue?vue&type=style&index=0&id=3576edca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3576edca",
  null
  
)

export default component.exports